import React from "react";
import { IColuna } from "../../../types/IColuna";
const estiloEstoque = require(".././estoque.module.scss").default;

export type HeadersPesquisarClienteProps = {
  colunas: IColuna[];
};
const traduzirColuna = (nomeColuna: string) => {
  return nomeColuna == "Informações" ? "" : nomeColuna;
};

const alinhamentoColunaClasse = (nomeColuna: string) => {
  return ["Filial"].includes(nomeColuna) || ["Local Físico"].includes(nomeColuna) ? '_text-left' : '_text-right'
}

export const HeadersEstoque = React.memo((
  props: HeadersPesquisarClienteProps
) => {
  return (
    <thead id="HeadersEstoque_Thead">
      <tr>
        {props.colunas.map(
          (coluna, index) =>
            coluna.Selecionada && (
              <th
                className={`${estiloEstoque.tableCellHeader} ${alinhamentoColunaClasse(coluna.Nome)} `}
                key={coluna.Nome}
                id={`HeadersEstoque_Cabecalho_${coluna.Nome.replace(/\s+/g, '_')}_${index}`}
              >
                {traduzirColuna(coluna.Nome)}
              </th>
            )
        )}
      </tr>
    </thead>
  );
});
